import React, { useState } from "react";
import { Container, Row, Col, Form, Nav } from "react-bootstrap";
import Inbounds from "../components/Inbound/Inbounds";

const Inbound = ({ history, location: { state } }) => {
  const [currentAuctionHouse, setCurrentAuctionHouse] = useState(
    sessionStorage.getItem("SELECTED_AUCTIONHOUSE")
      ? JSON.parse(sessionStorage.getItem("SELECTED_AUCTIONHOUSE"))
      : state[0]
  );
  const [navOptions, setNavOptions] = useState("inbounds");

  const handleSelectAuctionHouse = (e) => {
    const selectedAuctionHouse = state.filter(
      (el) => el.name === e.target.value
    );
    setCurrentAuctionHouse(selectedAuctionHouse[0]);
    sessionStorage.setItem(
      "SELECTED_AUCTIONHOUSE",
      JSON.stringify(selectedAuctionHouse[0])
    );
  };

  return (
    <Container as="main" fluid>
      <Row>
        <Col xs={12} className="mt-2">
          <Form.Select
            aria-label="Select Auction House"
            onChange={handleSelectAuctionHouse}
          >
            {state.map((auctionHouse) => (
              <option key={auctionHouse.id} value={auctionHouse.name}>
                {auctionHouse.name}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="mt-3">
          <Nav fill variant="tabs" defaultActiveKey="inbounds">
            <Nav.Item>
              <Nav.Link
                eventKey="inbounds"
                onClick={() => setNavOptions("inbounds")}
              >
                Inbounds
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="mt-3">
          {navOptions === "inbounds" && (
            <Inbounds auctionHouse={currentAuctionHouse} />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Inbound;
